import React from "react";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  return (
    <div className="absolute top-0 left-0 w-full flex justify-end items-center p-4 bg-transparent z-30">
      <div>
        <div className="flex items-center space-x-6 text-white">
          <span className="text-sm">+92 334 8832744</span>
          {/* <a href="#services" className="text-sm">
            Pricing
          </a>
          <button href="#" className="text-sm">
            Agents
          </button> */}
          <a href="#contact-us" className="text-sm">
            Contact Us
          </a>
          <div className="flex space-x-2">
            <a
              href="#calculator"
              className="bg-[#457b9d] hover:bg-[#1d3557] text-white px-4 py-2 rounded"
            >
              COST CALCULATOR
            </a>
            <button
              onClick={() => navigate("/signin")}
              className="bg-[#457b9d] hover:bg-[#1d3557] text-white px-4 py-2 rounded"
            >
              Sign In
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
